import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._8,
  },

  dropdownContainer: {
    width: '100%',
    paddingBottom: theme.other.spacing._8,
    marginTop: theme.other.spacing._16,
  },

  box: {
    display: 'flex',
    width: '100%',
    padding: theme.other.spacing._16,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.other.spacing._8,
    background: theme.colors.gray2[0],
    borderRadius: theme.radius.lg,
  },

  row: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.other.spacing._8,
  },

  content: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: theme.other.spacing._8,
    borderTop: `1px solid ${theme.colors.gray2[1]}`,
    paddingTop: theme.other.spacing._16,
    paddingBottom: theme.other.spacing._8,
  },

  footer: {
    width: '100%',
    borderTop: `1px solid ${theme.colors.gray2[1]}`,
    color: theme.colors.gray2[7],
    paddingTop: theme.other.spacing._8,
  },

  footnote: {
    padding: theme.other.spacing._4,
    paddingTop: theme.other.spacing._8,
  },
}));
